import React, { useId } from "react";

import { Label, Text } from "@flare/ui/components";

interface Props {
  errorMessage?: string;
  field: (id: string) => React.ReactNode;
  label: React.ReactNode;
}

export function FormField({ field, label, errorMessage }: Props) {
  const id = useId();

  return (
    <div className="flex w-full flex-col gap-sp-1">
      <div className="flex flex-col gap-sp-2">
        <Label htmlFor={id} className="text-body2">
          {label}
        </Label>

        {field(id)}
      </div>
      {errorMessage && (
        <Text variant="caption" className="text-danger-highlight">
          {errorMessage}
        </Text>
      )}
    </div>
  );
}
